import React, { Component } from 'react';
import dateFormat from 'dateformat'
import { RegisterLicense } from '../api/licenses'
import { Alert } from 'react-bootstrap'
import StatusMessage from "../lib/statusmessage"


class DeveloperLicense extends Component {

    constructor(props) {
        super(props);
        this.app_key_prefixes = ['XA', 'XU', 'XI', 'XE', 'SU', 'AJ', 'S9', 'SE'];
        this.state = {
            License: this.props.license || null,
            Registering: false,
            Alert: null
        }

        this.registerSerial = this.registerSerial.bind(this);
    }

    async registerSerial() {

        try {
            this.setState({
                Registering: true
            })
            let register = await RegisterLicense({ key: this.state.License.Key });

            if (register.success) {
                this.setState({
                    License: {
                        ...this.state.License,
                        JustRegistered: true
                    }
                });

            }

            this.setState({
                Alert: new StatusMessage({
                    Status: register.success ? "success" : "danger",
                    Message: register.message,
                })
            })

        } catch (ex) {
            this.setState({
                Alert: new StatusMessage({
                    Status: 'danger',
                    Message: `${ex}`,
                })

            })
        } finally {
            this.setState({
                Registering: false
            })
        }
    }


    render() {

        return (<div>

            <div className="row mylicense-wrapper">
                <div className="col-md-8 mylicense-meta">
                    {this.state.Alert &&
                        <Alert variant={this.state.Alert.Status}>
                            {this.state.Alert.Message}
                        </Alert>
                    }
                    <h5>{this.state.License.ProductSku.ProductName}</h5>
                    {(()=>{
                        if(this.state.License.Addons.length && this.state.License.Addons.length>0){
                            return(
                                <p class="m-1"><strong>AddOn(s): </strong> 
                                {this.state.License.Addons.map((item)=>{
                                    return item.Name;
                                })}
                                </p>
                            )
                        }
                    })()}
                    <p class="m-1"><strong>Serial Key:</strong> {this.state.License.Key}</p>
                    {(() => {
                        if (this.state.License.ProductSku.ProductName && this.state.License.ProductSku.ProductName.indexOf("Fulfillment") == -1 && this.state.License.PurchaseDate) {
                            return (<p class="m-1"><strong>Purchased:</strong> {dateFormat(this.state.License.PurchaseDate, "mmmm dS, yyyy")}</p>)
                        }
                    })()}

                    {(() => {
                        if (this.state.License.Subscription) {
                            if (this.state.License.Subscription.EndDate && (this.state.License.ProductSku.ProductName&&this.state.License.ProductSku.ProductName.indexOf("Fulfillment") == -1)) {
                                return (<p class="m-1"><strong>Subscription Ends:</strong> {dateFormat(this.state.License.Subscription.EndDate, "mmmm dS, yyyy")}</p>)
                            }
                        }
                    })()}

                    {(() => {
                        if (this.state.License.Registration) {
                            return (<p class="m-1"><strong>Registered to:</strong> {this.state.License.Registration.FullName}</p>)
                        } else if (this.state.License.JustRegistered) {
                            return (<p class="m-1"><strong>Registered to:</strong> Me</p>)
                        } else {
                            //ToDO registration button
                            return (<button type="button" onClick={this.registerSerial} className="gc-btn primary-action">Register Now{this.state.Registering && <i className="fa fa-spinner fa-spin"></i>}</button>)
                        }

                    })()}


                </div>
                <div className="col-md-4 mylicense-actions">
                    <ul>
                        <li>Actions:</li>
                        <li>
                            <a href={"/my-account/my-downloads/" + this.state.License.encKey} title="Get Installers">Downloads</a>
                        </li>
                        {(() => {

                            if (this.app_key_prefixes.includes(this.state.License.Key.slice(0, 2))) {
                                return <li><a href={"/my-account/create-app-key/" + this.state.License.encKey} title="Create an App Key">Create an App Key</a></li>
                            }

                        })()}

                    </ul>
                </div>

            </div>

        </div>)
    }
}

export default DeveloperLicense;